function mui() {
  let fired = false;

  function kickTrigger() {
    if (fired) return;

    fired = true;

    window.dispatchEvent(new CustomEvent("minimal-user-interaction"));
  }

  document.addEventListener("focus", kickTrigger, { once: true, passive: true });
  document.addEventListener("mousemove", kickTrigger, { once: true, passive: true });
  document.addEventListener("wheel", kickTrigger, { once: true, passive: true });
  document.addEventListener("touchstart", kickTrigger, { once: true, passive: true });
}

mui();
